<style lang="less">
  @import "./TuyunDownload.less";
</style>

<template>
  <div class="tuyun-download">
  </div>
</template>

<script>
import TuyunDownload from './TuyunDownload.js'
export default {
  ...TuyunDownload
}
</script>
